import React, { useState } from "react";
import "./PjpDayCard.css";
import { PjpDayCardType, PjpDayCardProps } from "./PjpSummaryCardTypes";
import EventNoteIcon from "@mui/icons-material/EventNote";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../providers/TranslationProvider";
import { Box } from "@mui/material";
import nhTown from "./images/nhTown.png";
import startTown from "./images/startTown.png";
import workTown from "./images/workTown.png";
import meetingTown from "./images/meetingTown.png";

const Card: React.FC<PjpDayCardType> = ({...PjpDayData }) => {
  const { translate } = usePortalTranslation();

  const [showDetails, setShowDetails] = useState<boolean>(false);

  return (
    <div
      className="card"
      onClick={() => setShowDetails((prevState: any) => !prevState)}
      style={{
        borderLeftColor: PjpDayData.textColor,
        borderLeftWidth: "4px",
        borderLeftStyle: "solid",
      }}
    >
      <div className="date-status">
        <div className="date">
          <EventNoteIcon />
          {PjpDayData.date}
        </div>
        <div>
          {(
            (!PjpDayData.showDetail &&
              PjpDayData.PJPPlan?.toLowerCase() === "retailing") ||

            (PjpDayData.showDetail &&
              !["weekly off", "leave", "holiday"].includes(
                PjpDayData.PJPPlan?.toLowerCase()
              ))
          ) &&
            (
              <div
                className="label"
                style={{
                  backgroundColor: `${PjpDayData.textColor}1A`,
                  color: PjpDayData.textColor,
                }}
              >
                {PjpDayData.PJPPlan}
              </div>
            )}
        </div>
      </div>

      <div>
        {(
          (!PjpDayData.showDetail &&
            PjpDayData.PJPPlan?.toLowerCase() !== "retailing") ||

          (PjpDayData.showDetail &&
            ["weekly off", "leave", "holiday"].includes(
              PjpDayData.PJPPlan?.toLowerCase()
            ))
        ) && (
            <div
            className="label"
            style={{
              backgroundColor: `${PjpDayData.textColor}1A`,
              color: PjpDayData.textColor,
              width: "100%",
              marginTop: "1.5rem",
            }}
          >
            {PjpDayData.PJPPlan}
          </div>
        )}
      </div>

      {(
        (!PjpDayData.showDetail &&
          PjpDayData.PJPPlan?.toLowerCase() === "retailing") ||

        (PjpDayData.showDetail &&
          !["weekly off", "leave", "holiday"].includes(
            PjpDayData.PJPPlan?.toLowerCase()
          ))
      ) &&
        (
          <div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "end",
              }}
            >
              <div className="details">
                {(PjpDayData.showVisitPlan) && (<div>{translate(TranslationEnum.pjp_approval, "Visit Plan")}: {PjpDayData.visitPlan || "N/A"}</div>)}
                <div>{translate(TranslationEnum.pjp_approval, "Beat")} : {PjpDayData.beat || "NA"}</div>
              </div>

            {PjpDayData.showDetail && (<div className="expand-details">
              {showDetails ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </div>)}
            </Box>

            {PjpDayData.showDetail && showDetails && (
              <div className="town-details">
                {PjpDayData.startTown && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={startTown}
                        alt="Start Town"
                        className="town-icon"
                      />
                      <span >Start Town</span>
                    </span>
                    <span className="town-value">{PjpDayData.startTown}</span>
                  </div>
                )}

                {PjpDayData.workTown && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={workTown}
                        alt="Work Town"
                        className="town-icon"
                      />
                      <span>Work Town</span>
                    </span>
                    <span className="town-value">{PjpDayData.workTown}</span>
                  </div>
                )}

                {PjpDayData.nhTown && (
                  <div className="town-row">
                    <span className="town-label">
                      <img src={nhTown} alt="NH Town" className="town-icon" />
                      <span >NH Town</span>
                    </span>
                    <span className="town-value">{PjpDayData.nhTown}</span>
                  </div>
                )}

                {PjpDayData.meetingTown && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={meetingTown}
                        alt="Meeting Town"
                        className="town-icon"
                      />
                      <span>Meeting Town</span>
                    </span>
                    <span className="town-value">{PjpDayData.meetingTown}</span>
                  </div>
                )}

                {PjpDayData.nhExist && (
                  <div className="town-row">
                    <span className="town-label">
                      <img src={nhTown} alt="NH Exist" className="town-icon" />
                      <span >NH Exist</span>
                    </span>
                    <span className="town-value">{PjpDayData.nhExist}</span>
                  </div>
                )}

                {PjpDayData.routeCodeValid && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={nhTown}
                        alt="Route Code Exist"
                        className="town-icon"
                      />
                      <span>Route Code Exist</span>
                    </span>
                    <span className="town-value">
                      {PjpDayData.routeCodeValid}
                    </span>
                  </div>
                )}

                {PjpDayData.routeCodeNHValid && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={nhTown}
                        alt="Route Code NH Exist"
                        className="town-icon"
                      />
                      <span>Route Code NH Exist</span>
                    </span>
                    <span className="town-value">
                      {PjpDayData.routeCodeNHValid}
                    </span>
                  </div>
                )}

                {PjpDayData.statusRemarks &&
                  PjpDayData.status &&
                  PjpDayData.status.toLowerCase().includes("approve") && (
                    <div className="town-row">
                      <span className="town-label">
                        <img
                          src={nhTown}
                          alt="Manager Comment"
                          className="town-icon"
                        />
                        <span>Manager Comment</span>
                      </span>
                      <span className="town-value">
                        {PjpDayData.statusRemarks}
                      </span>
                    </div>
                  )}
              </div>
            )}
          </div>
        )}
    </div>
  );
};

const PjpDayCard: React.FC<PjpDayCardProps> = ({ dayCardData }) => {
  return (
    <div className="card-container">
      {dayCardData?.map((data, index) => (
        <Card key={index} {...data} />
      ))}
    </div>
  );
};

export default PjpDayCard;
